// extracted by mini-css-extract-plugin
module.exports = {"CreateGist":"CreateFleetingNote_CreateGist__1QrS1"};